import { Stack } from 'src/components/Stack';

import { CustomBlockingReason } from './CustomBlockingReason';
import { PaymentRequiredReason } from './PaymentRequiredReason';
import { WaiverRequiredReason } from './WaiverRequiredReason';
import { CheckinBlocker } from './_types';

export function BlockingReasonList({
  blockers,
  inlineActions = false,
  userId,
}: {
  blockers: CheckinBlocker[];
  inlineActions?: boolean;
  userId: string;
}) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      {blockers.map((blocker, index) => {
        const key = `${blocker.type}-${index}`;
        switch (blocker.type) {
          case 'paymentRequired':
            return (
              <PaymentRequiredReason
                key={key}
                userId={userId}
                inlineActions={inlineActions}
              />
            );
          case 'billing_blocked':
            return (
              <PaymentRequiredReason
                key={key}
                userId={userId}
                inlineActions={inlineActions}
              />
            );
          case 'waiverRequired':
            return (
              <WaiverRequiredReason
                key={key}
                _userId={userId}
                inlineActions={inlineActions}
              />
            );
          default:
            return (
              <CustomBlockingReason
                key={key}
                title={blocker.title ?? ''}
                message={blocker.message ?? ''}
              />
            );
        }
      })}
    </Stack>
  );
}
